import { render, staticRenderFns } from "./SnippetTemplate.vue?vue&type=template&id=37f5ffee&scoped=true&"
import script from "./SnippetTemplate.vue?vue&type=script&lang=js&"
export * from "./SnippetTemplate.vue?vue&type=script&lang=js&"
import style0 from "./SnippetTemplate.vue?vue&type=style&index=0&id=37f5ffee&lang=scss&scoped=true&rel=stylesheet%2Fscss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37f5ffee",
  null
  
)

export default component.exports